var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "time-choose-menu", attrs: { id: "time-choose-menu" } },
    [
      _c("section", { staticClass: "menu-ctrl" }, [
        _c("span", { staticClass: "menu-ctrl__text" }, [
          _vm._v(_vm._s(_vm.$t("__time_choose.top_hint")))
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "time-choose", attrs: { id: "time-choose" } },
        [
          _c("TreeView", {
            attrs: {
              init_items: _vm.init_items,
              checked_selectors: _vm.checked_selectors,
              init_opened_layers: _vm.init_opened_layers,
              check_function: _vm.change_time_status,
              enable_custom_label: true
            },
            scopedSlots: _vm._u([
              {
                key: "content",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    item.name === _vm.$t("__time_choose.customized_search")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "history-search history-search__container",
                            class: {
                              "cursor-auto": _vm.is_disabled(
                                _vm.$t("__time_choose.customized_search")
                              )
                            }
                          },
                          [
                            _c(
                              "v-menu",
                              {
                                attrs: {
                                  "close-on-content-click": false,
                                  "nudge-right": 40,
                                  transition: "scale-transition",
                                  "offset-y": "",
                                  "min-width": "290px"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              {
                                                staticClass:
                                                  "start-date__text-field",
                                                attrs: {
                                                  label: _vm.$t(
                                                    "__time_choose.start_date_label"
                                                  ),
                                                  disabled: _vm.is_disabled(
                                                    _vm.$t(
                                                      "__time_choose.customized_search"
                                                    )
                                                  ),
                                                  readonly: "",
                                                  color: "white",
                                                  "hide-details": ""
                                                },
                                                model: {
                                                  value: _vm.date,
                                                  callback: function($$v) {
                                                    _vm.date = $$v
                                                  },
                                                  expression: "date"
                                                }
                                              },
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: _vm.menu_date,
                                  callback: function($$v) {
                                    _vm.menu_date = $$v
                                  },
                                  expression: "menu_date"
                                }
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "v-date-picker",
                                  {
                                    attrs: {
                                      locale:
                                        _vm.language !== "en" ? "zh-tw" : "en",
                                      min: _vm.allowed_min_date,
                                      max: _vm.allowed_max_date
                                    },
                                    model: {
                                      value: _vm.model_date,
                                      callback: function($$v) {
                                        _vm.model_date = $$v
                                      },
                                      expression: "model_date"
                                    }
                                  },
                                  [
                                    _c("v-spacer"),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { text: "", color: "primary" },
                                        on: { click: _vm.cancel_date_pick }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$t("__time_choose.cancel")
                                            ) +
                                            "\n                            "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { text: "", color: "primary" },
                                        on: {
                                          click: function($event) {
                                            return _vm.toggle_generate_time_durations(
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$t("__time_choose.decide")
                                            ) +
                                            "\n                            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-menu",
                              {
                                ref: "menu_time",
                                attrs: {
                                  "close-on-content-click": false,
                                  "nudge-right": 40,
                                  transition: "scale-transition",
                                  "offset-y": "",
                                  "max-width": "290px",
                                  "min-width": "290px"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              {
                                                staticClass:
                                                  "start-time__text-field",
                                                attrs: {
                                                  label: _vm.$t(
                                                    "__time_choose.start_time_label"
                                                  ),
                                                  disabled: _vm.is_disabled(
                                                    _vm.$t(
                                                      "__time_choose.customized_search"
                                                    )
                                                  ),
                                                  readonly: "",
                                                  color: "white",
                                                  "hide-details": ""
                                                },
                                                model: {
                                                  value: _vm.time,
                                                  callback: function($$v) {
                                                    _vm.time = $$v
                                                  },
                                                  expression: "time"
                                                }
                                              },
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: _vm.menu_time,
                                  callback: function($$v) {
                                    _vm.menu_time = $$v
                                  },
                                  expression: "menu_time"
                                }
                              },
                              [
                                _vm._v(" "),
                                _vm.menu_time
                                  ? _c(
                                      "v-time-picker",
                                      {
                                        attrs: {
                                          format: "24hr",
                                          "allowed-minutes":
                                            _vm.allowed_minutes,
                                          max: _vm.allowed_max_time
                                        },
                                        model: {
                                          value: _vm.model_time,
                                          callback: function($$v) {
                                            _vm.model_time = $$v
                                          },
                                          expression: "model_time"
                                        }
                                      },
                                      [
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                text: "",
                                                color: "primary"
                                              },
                                              on: {
                                                click: _vm.back_to_date_picker
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { size: "16" } },
                                                [
                                                  _vm._v(
                                                    "\n                                        icon-arrow-back\n                                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "__time_choose.back_to_date_select"
                                                    )
                                                  ) +
                                                  "\n                                "
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-spacer"),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                text: "",
                                                color: "primary"
                                              },
                                              on: {
                                                click: _vm.cancel_time_pick
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "__time_choose.cancel"
                                                    )
                                                  ) +
                                                  "\n                                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                text: "",
                                                color: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.toggle_generate_time_durations()
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "__time_choose.decide"
                                                    )
                                                  ) +
                                                  "\n                                "
                                              )
                                            ]
                                          )
                                        ]
                                      ],
                                      2
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("v-select", {
                              staticClass: "display-internal",
                              attrs: {
                                items: _vm.time_duration,
                                label: _vm.$t(
                                  "__time_choose.display_interval_label"
                                ),
                                disabled: _vm.is_disabled(
                                  _vm.$t("__time_choose.customized_search")
                                ),
                                color: "white"
                              },
                              on: { change: _vm.change_duration },
                              model: {
                                value: _vm.selected_time_duration,
                                callback: function($$v) {
                                  _vm.selected_time_duration = $$v
                                },
                                expression: "selected_time_duration"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    item.name === "個案查詢" &&
                    Object.keys(_vm.all_cases).length > 0
                      ? _c(
                          "div",
                          {
                            staticClass: "case-search case-search__container",
                            class: {
                              "cursor-auto": _vm.is_disabled("個案查詢")
                            }
                          },
                          [
                            _c("v-select", {
                              attrs: {
                                items: _vm.case_year_list,
                                disabled: _vm.is_disabled("個案查詢"),
                                label: "年份",
                                "hide-details": "",
                                color: "white"
                              },
                              on: {
                                change: function($event) {
                                  _vm.generate_single_case()
                                  _vm.control_case_selector_dialog(true)
                                }
                              },
                              model: {
                                value: _vm.current_case_year,
                                callback: function($$v) {
                                  _vm.current_case_year = $$v
                                },
                                expression: "current_case_year"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("v-select", {
                                  attrs: {
                                    items: _vm.case_group_by_year,
                                    disabled: _vm.is_disabled("個案查詢"),
                                    label: "個案",
                                    "hide-details": "",
                                    color: "white"
                                  },
                                  model: {
                                    value: _vm.current_case,
                                    callback: function($$v) {
                                      _vm.current_case = $$v
                                    },
                                    expression: "current_case"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "case-search__internal-text" },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.display_case_datetime) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "case-search__selector-btn",
                                class: {
                                  "case-search__selector-btn--active":
                                    _vm.time_selected === "個案查詢"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.control_case_selector_dialog(
                                      true
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                        開啟選取個案介面\n                    "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-dialog",
                              {
                                attrs: {
                                  "content-class": "case-search__dialog"
                                },
                                model: {
                                  value: _vm.is_show_case_selector,
                                  callback: function($$v) {
                                    _vm.is_show_case_selector = $$v
                                  },
                                  expression: "is_show_case_selector"
                                }
                              },
                              [
                                _c("CaseSelector", {
                                  attrs: { init_year: _vm.current_case_year },
                                  on: {
                                    "control-case-selector-dialog":
                                      _vm.control_case_selector_dialog,
                                    "enter-case-mode": _vm.enter_case_mode
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }